import React from 'react';
import emailjs from 'emailjs-com';
import axios from 'axios';

import { baseURL } from './baseURL';

const Contact = (props) => {

    if (props.data) {
		var name = props.data.name;
		var number = props.data.address.number;
		var street = props.data.address.street;
		var town = props.data.address.town;
		var city = props.data.address.city;
		var zip = props.data.address.zip;
		var phone= props.data.phone;
		var email = props.data.email;
		var message = props.data.contactmessage;
    }

	function sendEmail(e) {
		var contactName = document.getElementById("contactName").value;
		var contactEmail = document.getElementById("contactEmail").value;
		var contactSubject = document.getElementById("contactSubject").value;
		var contactMessage = document.getElementById("contactMessage").value;

		const message = {
			contactName: contactName,
			contactEmail: contactEmail,
			contactSubject: contactSubject,
			contactMessage: contactMessage
		};

		e.preventDefault();

		emailjs.sendForm('service_gnge9x9', 'template_vbn4e9a', e.target, 'user_ol369eLXPCzRCc4tIXJne')
		.then((result) => {
			console.log(result.text);
			alert("Message sent successfully via Email!");
			e.target.reset();
		}, (error) => {
			console.log(error.text);
			alert("Message sending failed via Email!");
		});

		axios.post(`${baseURL}/message/create`, message)
		.then((res) => {
			console.log(res.data);
			alert("Message sent successfully via SMS!");
		})
		.catch((err) => {
			console.log(err.response.data.msg);
			alert("Message sending failed via SMS!");
		});
	}

    return (
		<section id="contact">
			<div className="row section-head">
				<div className="two columns header-col">
					<h1><span>Get In Touch.</span></h1>
				</div>
				<div className="ten columns">
					<p className="lead">{message}</p>
				</div>
			</div>
			<div className="row">
				<div className="eight columns">
					<form className="contact-form" onSubmit={sendEmail}>
						<fieldset>
							<div>
								<label htmlFor="contactName">Name <span className="required">*</span></label>
								<input type="text" defaultValue="" size="35" id="contactName" name="contactName" required />
							</div>
							<div>
								<label htmlFor="contactEmail">Email <span className="required">*</span></label>
								<input type="text" defaultValue="" size="35" id="contactEmail" name="contactEmail" required />
							</div>
							<div>
								<label htmlFor="contactSubject">Subject <span className="required">*</span></label>
								<input type="text" defaultValue="" size="35" id="contactSubject" name="contactSubject" required />
							</div>
							<div>
								<label htmlFor="contactMessage">Message <span className="required">*</span></label>
								<textarea cols="50" rows="15" id="contactMessage" name="contactMessage" required></textarea>
							</div>
							<div>
								<button className="submit" type="submit">Submit</button>
								{/* <span id="image-loader">
									<img alt="" src="images/loader.gif" />
								</span> */}
							</div>
						</fieldset>
					</form>

					<div id="message-warning"> Error</div>
					<div id="message-success">
						<i className="fa fa-check"></i>Your message was sent, thank you!<br />
					</div>
				</div>
				<aside className="four columns footer-widgets">
					<div className="widget widget_contact">
						<h4>Address, Phone and Email</h4>
						<p className="address">
							{name}, <br />
							{number}, <br />
							{street}, <br />
							{town}, <br />
							{city}, <br />
							{zip}. <br />
							<span>{phone}</span> <br />
							<span>{email}</span>
						</p>
					</div>
					<div className="widget widget_tweets">
						<h4 className="widget-title">Contact Me at Socials</h4>
						<ul id="twitter">
							<li>
								<span>
									Twitter: &nbsp;
									<a href="https://twitter.com/DeelakaIniesta">https://twitter.com/DeelakaIniesta</a>
								</span>
							</li>
							<li>
								<span>
									LinkedIn: &nbsp;
									<a href="https://www.linkedin.com/in/dasith-deelaka-1a0019160/">https://www.linkedin.com/in/dasith-deelaka-1a0019160/</a>
								</span>
							</li>
							<li>
								<span>
									Facebook: &nbsp;
									<a href="https://www.facebook.com/dasith.d.jagoda/">https://www.facebook.com/dasith.d.jagoda/</a>
								</span>
							</li>
							<li>
								<span>
									Instagram: &nbsp;
									<a href="https://www.instagram.com/deelaka_iniesta/">https://www.instagram.com/deelaka_iniesta/</a>
								</span>
							</li>
						</ul>
					</div>
				</aside>
			</div>
		</section>
    );
}

export default Contact;